export default "__VITE_ASSET__CzVlz5E7__"